import { render, staticRenderFns } from "./channelout.vue?vue&type=template&id=3bc33094&scoped=true&"
import script from "./channelout.vue?vue&type=script&lang=js&"
export * from "./channelout.vue?vue&type=script&lang=js&"
import style0 from "./channelout.vue?vue&type=style&index=0&id=3bc33094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc33094",
  null
  
)

export default component.exports